import { createSlice } from '@reduxjs/toolkit';
import {
    coordenadas,
} from '../actions/coordenadas';


export const CoordenadasReducer = createSlice({
    name: 'coordenadas',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(coordenadas.pending, (state) => { state.loading = true })
            .addCase(coordenadas.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(coordenadas.rejected, (state) => { state.loading = false })
    }
})
export default CoordenadasReducer.reducer;